// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  customerId: __t.string().unique().name("customer_id"),
  subscriptionId: __t.string().name("subscription_id"),
  workspaceOwner: __t.identity().name("workspace_owner"),
  status: __t.string(),
  tier: __t.string(),
  currentPeriodStart: __t.i64().name("current_period_start"),
  currentPeriodEnd: __t.i64().name("current_period_end"),
  cancelAtPeriodEnd: __t.bool().name("cancel_at_period_end"),
  updatedAt: __t.i64().name("updated_at"),
});
